import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {CommonService} from './common.service';
import {map} from 'rxjs/operators';
import {BehaviorSubject, Observable} from 'rxjs';
import {
  ContentPosition,
  SignatureConfig
} from 'src/app/modules/dashboard/home/home-enterprise/document/sign-flow-document/signature-config.model';
import {InjectorInstant} from 'src/app/app.component';
import {
  imageConfigFormPreviewId,
  imageConfigViewScaleId
} from 'src/app/modules/dashboard/home/home-enterprise/document/sign-flow-document/image-sign-config/image-sign-config.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';

const routes = {
  // tslint:disable-next-line:max-line-length
  generateTransaction: (documentId: string, numberPhone: string) => `/digital-signature/otp/generate-transaction/${documentId}/${numberPhone}`,
  generateTransactionDirectly: (documentId: string, numberPhone: string) => `/digital-signature/otp/generate-transaction-directly/${documentId}/${numberPhone}`,
  signOtp: () => `/digital-signature/sign/otp`,
  signOtpDirectly: () => `/digital-signature/sign/otp-directly`,
  signatureServer: () => `/digital-signature/sign/server-signature`,
  signatureServerDirectly: () => `/digital-signature/sign/server-signature-directly`,
  signWithImageNoCertificateDirectly: () => `/digital-signature/sign/image-without-certificate-directly`,
  signHSM: () => `/hsm/hsm-sign`,
  signSimCA: () => `/digital-signature/sign/sim-ca`,
  signSimCADirectly: () => `/digital-signature/sign/sim-ca-directly`,
  signatureServerWithImage: () => `/digital-signature/sign/server-signature-image-multi-pos`,
  signatureServerDirectlyWithImage: () => `/digital-signature/sign/server-signature-directly-image`,
  signSimCAWithImage: () => `/digital-signature/sign/sim-ca-image-multiple-pos`,
  signSimCAMohaWithImage: () => `/digital-signature/tindy/sign/sim-ca-image-multiple-pos`,
  signCloudCAWithImage: () => `/digital-signature/sign/cloud-ca-image-multiple-pos`,
  signCloudCAMohaWithImage: () => `/digital-signature/tindy/sign/cloud-ca-image-multiple-pos`,
  reSignCloudCAMohaWithImage: () => `/digital-signature/sign-contract-standardized/cloud-ca`,
  signEasyCAWithImage: () => `/digital-signature/sign/easy-ca-image-multiple-pos`,
  signOtpWithImage: () => `/digital-signature/sign/otp-image-multi-pos`,
  signWithImageNoCertificate: () => `/digital-signature/sign/image-without-certificate-multi-pos`,
  signSimCADirectlyWithImage: () => `/digital-signature/sign/sim-ca-directly-image`,
  SignWithImage: () => '/digital-signature/sign/with-image',
  SignOtpNoImage: () => '/digital-signature/sign/otp-no-image-multi-pos',
  signatureServerNoImage: () => '/digital-signature/sign/server-signature-no-image-multi-pos',
  signatureServerDirectlyNoImage: () => '/digital-signature/sign/server-signature-directly-no-image',
  signSimCADirectlyNoImage: () => '/digital-signature/sign/sim-ca-directly-no-image',
  signSimCANoImage: () => '/digital-signature/sign/sim-ca-no-image-multiple-pos',
  signCloudCANoImage: () => '/digital-signature/sign/cloud-ca-no-image-multiple-pos',
  signVNeIDWithImage: () => '/digital-signature/sign/vneid',
  signDone: (signLot?: boolean) => `/digital-signature/sign/done${signLot ? '?signLot=true' : ''}`,
  signDoneDigital: (signLot?: boolean) => `/digital-signature/sign/done?type=5${signLot ? '&signLot=true' : ''}`,
  signCancel: (signLot?: boolean) => `/digital-signature/sign/cancel${signLot ? '?signLot=true' : ''}`,
  signCancelWait: (signLot?: boolean) => `/digital-signature/sign/cancel${signLot ? '?signLot=true' : ''}&type=4`,
  valiadateEkycOtpSupport: () => '/ekyc/validate-ekyc-otp-support',
  ekycSupportWithoutImageNoCtsMb: () => '/ekyc/sign-ekyc-support/image-without-certificate-mobile-multi-pos',
  getQuantityEkyc: (contractId: string) => `/ekyc/get-quantity-by-contractId/${contractId}`,
  verifyEkyc: () => '/ekyc/verify-ekyc',
  getStatusSign: () => `/digital-signature/sign/get-sign-transaction-result`,
  shareResource: () => `/enterprises/resources/share`,
  //moha report
  getStatusSignReportMoha: () => `/moha-report/sign/transaction-result`,
  signCloudCAWithImageMohaReport: () => `/moha-report/sign/mysign/init`,
  signSimCAWithImageMohaReport: () => `/moha-report/sign/sim-ca/init`,
  signCloudCAMohaDigital : () => `/digital-signature/contract-employment/sign-and-approve`,
  signDoneUsb: `/digital-signature/contract-employment/sign/done`
};

const routesConfig = {
  getDate: '/common/get-date',
  getEmail: '/user-config/get-email-user',
  getEmailAnonymous:(hashKey)=> `/user-config/get-email-user-cloud-ca?hashKey=${hashKey}`,
  getUserConfig: '/user-config/get-user-config',
  userConfig: '/user-config/save-user-config'
}


@Injectable({
  providedIn: 'root'
})
export class SignDocumentService {
  openSigningDialog: BehaviorSubject<any> = new BehaviorSubject<any>(false)

  constructor(
    private apiService: ApiService,
    private commonService: CommonService
  ) {
  }

  /**
   * Generate Transaction for sign document with OTP
   * @param id document Id
   */
  generateTransaction(documentId: string, numberPhone: string, body: any) {
    return InjectorInstant.get(ApiService).post(routes.generateTransaction(documentId, numberPhone), body).pipe(map(res => {
      return res;
    }));
  }

  /**
   * Sign document with OTP
   * @param sign model sign
   */
  signOtp(sign) {
    return InjectorInstant.get(ApiService).post(routes.signOtp(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Sign document with signature server
   */
  signatureServer(sign) {
    return InjectorInstant.get(ApiService).post(routes.signatureServer(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Sign document with HSM
   */
  signHSM(sign) {
    return InjectorInstant.get(ApiService).post(routes.signHSM(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Sign document with Sim CA
   */
  signSimCA(sign) {
    return InjectorInstant.get(ApiService).post(routes.signSimCA(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  // Directly

  generateTransactionDirectly(documentId: string, numberPhone: string) {
    return InjectorInstant.get(ApiService).get(routes.generateTransactionDirectly(documentId, numberPhone));
  }

  signSimCADirectly(sign) {
    return InjectorInstant.get(ApiService).post(routes.signSimCADirectly(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signOtpDirectly(sign) {
    return InjectorInstant.get(ApiService).post(routes.signOtpDirectly(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signatureServerDirectly(sign) {
    return InjectorInstant.get(ApiService).post(routes.signatureServerDirectly(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  // ---------- Directly ---------
  // signWithImage
  signSimCADirectlyWithImage(sign) {
    return InjectorInstant.get(ApiService).postFormData(routes.signSimCADirectlyWithImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signWithImage(data) {
    return InjectorInstant.get(ApiService).postFormData(routes.SignWithImage(), data)
      .pipe(map(res => {
        return res;
      }));
  }

  signSimCAWithImage(sign) {
    return InjectorInstant.get(ApiService).postFormData(routes.signSimCAWithImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }
  signSimCAMohaWithImage(sign) {
    return InjectorInstant.get(ApiService).postFormData(routes.signSimCAMohaWithImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signCloudCAWithImage(sign) {
    return InjectorInstant.get(ApiService).postFormData(routes.signCloudCAWithImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  reSignCloudCAMohaWithImageBase64 = async (sign) => {
    const body = await this.toSignBodyBase64(sign);
    return InjectorInstant.get(ApiService).postFileBase64(routes.reSignCloudCAMohaWithImage(), body)
      .pipe(map(res => {
        return res;
      })).toPromise();
  }

  // reSignCloudCAMohaWithImage(sign) {
  //   return InjectorInstant.get(ApiService).postFormData(routes.reSignCloudCAMohaWithImage(), sign)
  //     .pipe(map(res => {
  //       return res;
  //     }));
  // }
  signCloudCAMohaWithImage(sign) {
    return InjectorInstant.get(ApiService).postFormData(routes.signCloudCAMohaWithImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }
  signSimCAWithImageMohaReport(sign) {
    return InjectorInstant.get(ApiService).postFormData(routes.signSimCAWithImageMohaReport(), sign)
      .pipe(map(res => {
        return res;
      }));
  }
  signCloudCAWithImageMohaReport(sign) {
    return InjectorInstant.get(ApiService).postFormData(routes.signCloudCAWithImageMohaReport(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signCloudCAMohaDigitalWithImage(sign) {
    return InjectorInstant.get(ApiService).postJson(
      routes.signCloudCAMohaDigital(),
      sign,
      {
        headers: new HttpHeaders({
          'Accept-Language': 'vi',
          'Tenant': localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId'),
          'Content-Type': 'application/json',
          'X-Silent-Loading': '1'
        })
      }
    ).pipe(map(res => {
      return res;
    }));
  }

  signEasyCAWithImage(sign) {
    return InjectorInstant.get(ApiService).postFormData(routes.signEasyCAWithImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signatureServerDirectlyWithImage(sign) {
    return InjectorInstant.get(ApiService).postFormData(routes.signatureServerDirectlyWithImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signatureServerImage(sign) {
    return InjectorInstant.get(ApiService).postFormData(routes.signatureServerWithImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signOtpWithImage(sign) {
    return InjectorInstant.get(ApiService).postFormData(routes.signOtpWithImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signWithImageNoCertificate(data) {
    return InjectorInstant.get(ApiService).postFormData(routes.signWithImageNoCertificate(), data)
      .pipe(map(res => {
        return res;
      }));
  }

  signWithImageNoCertificateDirectly(data) {
    return InjectorInstant.get(ApiService).postFormData(routes.signWithImageNoCertificateDirectly(), data)
      .pipe(map(res => {
        return res;
      }));
  }

  signVNeIDWithImage(sign) {
    return InjectorInstant.get(ApiService).postFormData(routes.signVNeIDWithImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Chuyen field image (File/Blob) trong body sang chuoi base64 de gui JSON thay multipart.
   */
  private async toSignBodyBase64(sign: any) {
    const body = {...sign};
    if (body.image instanceof Blob) {
      body.image = await this.commonService.getFileBase64(body.image as File);
    }
    return body;
  }

  // -------- Base64 versions (anh chu ky gui JSON base64 thay multipart binary - tranh bi Cloudflare chan) --------
  signSimCADirectlyWithImageBase64 = async (sign) => {
    const body = await this.toSignBodyBase64(sign);
    return InjectorInstant.get(ApiService).postFileBase64(routes.signSimCADirectlyWithImage(), body)
      .pipe(map(res => {
        return res;
      })).toPromise();
  }

  signWithImageBase64 = async (data) => {
    const body = await this.toSignBodyBase64(data);
    return InjectorInstant.get(ApiService).postFileBase64(routes.SignWithImage(), body)
      .pipe(map(res => {
        return res;
      })).toPromise();
  }

  signSimCAWithImageBase64 = async (sign) => {
    const body = await this.toSignBodyBase64(sign);
    return InjectorInstant.get(ApiService).postFileBase64(routes.signSimCAWithImage(), body)
      .pipe(map(res => {
        return res;
      })).toPromise();
  }

  signCloudCAWithImageBase64 = async (sign) => {
    const body = await this.toSignBodyBase64(sign);
    return InjectorInstant.get(ApiService).postFileBase64(routes.signCloudCAWithImage(), body)
      .pipe(map(res => {
        return res;
      })).toPromise();
  }

  signEasyCAWithImageBase64 = async (sign) => {
    const body = await this.toSignBodyBase64(sign);
    return InjectorInstant.get(ApiService).postFileBase64(routes.signEasyCAWithImage(), body)
      .pipe(map(res => {
        return res;
      })).toPromise();
  }

  signatureServerDirectlyWithImageBase64 = async (sign) => {
    const body = await this.toSignBodyBase64(sign);
    return InjectorInstant.get(ApiService).postFileBase64(routes.signatureServerDirectlyWithImage(), body)
      .pipe(map(res => {
        return res;
      })).toPromise();
  }

  signatureServerImageBase64 = async (sign) => {
    const body = await this.toSignBodyBase64(sign);
    return InjectorInstant.get(ApiService).postFileBase64(routes.signatureServerWithImage(), body)
      .pipe(map(res => {
        return res;
      })).toPromise();
  }

  signOtpWithImageBase64 = async (sign) => {
    const body = await this.toSignBodyBase64(sign);
    return InjectorInstant.get(ApiService).postFileBase64(routes.signOtpWithImage(), body)
      .pipe(map(res => {
        return res;
      })).toPromise();
  }

  signWithImageNoCertificateBase64 = async (data) => {
    const body = await this.toSignBodyBase64(data);
    return InjectorInstant.get(ApiService).postFileBase64(routes.signWithImageNoCertificate(), body)
      .pipe(map(res => {
        return res;
      })).toPromise();
  }

  signWithImageNoCertificateDirectlyBase64 = async (data) => {
    const body = await this.toSignBodyBase64(data);
    return InjectorInstant.get(ApiService).postFileBase64(routes.signWithImageNoCertificateDirectly(), body)
      .pipe(map(res => {
        return res;
      })).toPromise();
  }

  signVNeIDWithImageBase64 = async (sign) => {
    const body = await this.toSignBodyBase64(sign);
    return InjectorInstant.get(ApiService).postFileBase64(routes.signVNeIDWithImage(), body)
      .pipe(map(res => {
        return res;
      })).toPromise();
  }
  // ---------- image -----------

  // -------- no image ----------
  signSimCADirectlyNoImage(sign) {
    return InjectorInstant.get(ApiService).post(routes.signSimCADirectlyNoImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signSimCANoImage(sign) {
    return InjectorInstant.get(ApiService).post(routes.signSimCANoImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signCloudCANoImage(sign) {
    return InjectorInstant.get(ApiService).post(routes.signCloudCANoImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signatureServerDirectlyNoImage(sign) {
    return InjectorInstant.get(ApiService).post(routes.signatureServerDirectlyNoImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signatureServerNoImage(sign) {
    return InjectorInstant.get(ApiService).post(routes.signatureServerNoImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signOtpNoImage(sign) {
    return InjectorInstant.get(ApiService).post(routes.SignOtpNoImage(), sign)
      .pipe(map(res => {
        return res;
      }));
  }

  signDone(body, signLot?: boolean) {
    return InjectorInstant.get(ApiService).post(routes.signDone(signLot), body).pipe(map(res => {
      return res
    }));
  }

  signDoneDigital(body, signLot?: boolean) {
    return InjectorInstant.get(ApiService).post(routes.signDoneDigital(signLot), body).pipe(map(res => {
      return res
    }));
  }

  signDoneUsb(body, signLot?: boolean) {
    return InjectorInstant.get(ApiService).post(routes.signDoneUsb, body).pipe(map(res => {
      return res
    }));
  }

  signCancel(body, signLot?: boolean) {
    return InjectorInstant.get(ApiService).post(routes.signCancel(signLot), body).pipe(map(res => {
      return res
    }));
  }

  signCancelWait(body, signLot?: boolean) {
    return InjectorInstant.get(ApiService).post(routes.signCancelWait(signLot), body).pipe(map(res => {
      return res
    }));
  }

  // end no image ------------

  // validate-ekyc
  valiadateEkycOtpSupport(body: any): Observable<any> {
    return InjectorInstant.get(ApiService).post(routes.valiadateEkycOtpSupport(), body);
  }

  ekycSupportWithoutImageNoCtsMb(body: any): Observable<any> {
    return InjectorInstant.get(ApiService).post(routes.ekycSupportWithoutImageNoCtsMb(), body);
  }

  getQuantityEkyc(contractId: string) {
    if (!contractId) return;
    return InjectorInstant.get(ApiService).get(routes.getQuantityEkyc(contractId)).pipe(map(res => {
      return res
    }));
    ;
  }

  verifyEkyc(body: any): Observable<any> {
    return InjectorInstant.get(ApiService).post(routes.verifyEkyc(), body);
  }

  getStatusSign(signTransactionCode) {
    return InjectorInstant.get(ApiService).post(routes.getStatusSign(), signTransactionCode)
      .pipe(map(res => {
        return res;
      }));
  }
  getStatusSignReportMoha(signTransactionCode) {
    return InjectorInstant.get(ApiService).post(routes.getStatusSignReportMoha(), signTransactionCode)
      .pipe(map(res => {
        return res;
      }));
  }

  getDateAsync(): Observable<any> {
    return InjectorInstant.get(ApiService).get(routesConfig.getDate);
  }

  getEmailAsync(): Observable<any> {
    return InjectorInstant.get(ApiService).get(routesConfig.getEmail);
  }
  getEmailAnonymousAsync(hashKey?): Observable<any> {
    return InjectorInstant.get(ApiService).get(routesConfig.getEmailAnonymous(hashKey));
  }

  getUserConfigAsync(anonymousSign: boolean = false, isDigital: boolean = false): Observable<any> {
    let api = InjectorInstant.get(ApiService).get(routesConfig.getUserConfig + `${isDigital ? '?type=DIGITAL' : ''}`)
    if (anonymousSign) {
      api = InjectorInstant.get(ApiService).getWithAnonymousToken(routesConfig.getUserConfig)
    }

    return api.pipe(map(res => {
      console.log(res);
      if (res.success && res.data && res.data.signInfoConfig) {
        return {
          success: true,
          data: {
            enterpriseName: isDigital ? true : JSON.parse(res.data.signInfoConfig.issuedTo),
            greenTick: JSON.parse(res.data.signInfoConfig.tick),
            phoneNumber: JSON.parse(res.data.signInfoConfig.phone),
            signingTime: isDigital ? true : JSON.parse(res.data.signInfoConfig.dateTime),
            position: res.data.signInfoConfig.positionDetail ? JSON.parse(res.data.signInfoConfig.position) : false,
            address: res.data.signInfoConfig.addressDetail ? JSON.parse(res.data.signInfoConfig.address) : false,
            confirmBy: true,
            signature: res.data.signInfoConfig.signature,
            addressDetail: res.data.signInfoConfig.addressDetail,
            positionDetail: res.data.signInfoConfig.positionDetail,
            signatureImage: res.data.signInfoConfig.signatureImage,
            fontFamily: res.data.signInfoConfig.fontFamily ? res.data.signInfoConfig.fontFamily : 'Times-Roman',
            fontWeight: res.data.signInfoConfig.fontWeight,
            fontStyle: res.data.signInfoConfig.fontStyle,
            isDraw: res.data.signInfoConfig.isDraw,
            signatureImageBase64: res.data.signInfoConfig.signatureImageBase64 ? 'data:image/png;base64,' + res.data.signInfoConfig.signatureImageBase64 : null,
            signatureImageName: res.data.signInfoConfig.signatureImageName,
            signaturePosition: res.data.signInfoConfig.signaturePosition,
            signatureRatio: res.data.signInfoConfig.signatureRatio,
            email: JSON.parse(res.data.signInfoConfig.email),
            contentPosition: res.data.signInfoConfig.contentPosition || ContentPosition.left,
            customSymbol: res.data.signInfoConfig.customSymbolDetail ? res.data.signInfoConfig.customSymbol : false,
            customSymbolDetail: res.data.signInfoConfig.customSymbolDetail,
            organizationName: res.data.signInfoConfig.organizationNameDetail ? res.data.signInfoConfig.organizationName : false,
            organizationNameDetail: res.data.signInfoConfig.organizationNameDetail,
          }
        }
      } else return res;
    }));
  }

  postUserConfigAsync(body: SignatureConfig, isDigital: boolean = false): Observable<any> {
    console.log(body);
    const data = {
      issuedTo: body.enterpriseName.enabled,
      tick: body.greenTick.enabled,
      phone: body.phoneNumber ? body.phoneNumber.enabled : false,
      dateTime: body.signingTime.enabled,
      position: body.position.enabled,
      address: body.address.enabled,
      addressDetail: body.address.enabled ? body.address.value : null,
      positionDetail: body.position.enabled ? body.position.value : null,
      signatureImage: body.signatureImage.enabled,
      fontFamily: body.fontFamily.value ? body.fontFamily.value : null,
      fontWeight: body.fontWeight.value ? body.fontWeight.value : null,
      fontStyle: body.fontStyle.value ? body.fontStyle.value : null,
      signaturePosition: body.signaturePosition.value ? body.signaturePosition.value : null,
      signatureRatio: body.signatureRatio.value ? body.signatureRatio.value : null,
      signatureImageName: body.signatureImageName.value ? body.signatureImageName.value : null,
      isDraw: body.isDraw.enabled,
      signatureImageBase64: body.signatureImageBase64.value ? body.signatureImageBase64.value.split(',')[1] : null,
      email: body.email.enabled,
      contentPosition: body.contentPosition.value,
      type: isDigital ? 'DIGITAL': ''
    }
    return InjectorInstant.get(ApiService).post(routesConfig.userConfig, data);
  }

  postUserConfigDigitalAsync(body: SignatureConfig, isDigital: boolean = false): Observable<any> {
    console.log(body);
    const data = {
      issuedTo: body.enterpriseName.enabled,
      tick: body.greenTick.enabled,
      phone: body.phoneNumber ? body.phoneNumber.enabled : false,
      dateTime: body.signingTime.enabled,
      position: body.position.enabled,
      address: body.address.enabled,
      addressDetail: body.address.enabled ? body.address.value : null,
      positionDetail: body.position.enabled ? body.position.value : null,
      signatureImage: body.signatureImage.enabled,
      fontFamily: body.fontFamily.value ? body.fontFamily.value : null,
      fontWeight: body.fontWeight.value ? body.fontWeight.value : null,
      fontStyle: body.fontStyle.value ? body.fontStyle.value : null,
      signaturePosition: body.signaturePosition.value ? body.signaturePosition.value : null,
      signatureRatio: body.signatureRatio.value ? body.signatureRatio.value : null,
      signatureImageName: body.signatureImageName.value ? body.signatureImageName.value : null,
      isDraw: body.isDraw.enabled,
      signatureImageBase64: body.signatureImageBase64.value ? body.signatureImageBase64.value.split(',')[1] : null,
      email: body.email.enabled,
      contentPosition: body.contentPosition.value,
      type: isDigital ? 'DIGITAL': '',
      customSymbol: body.customSymbol.enabled,
      customSymbolDetail: body.customSymbol.enabled ? body.customSymbol.value : '',
      organizationName: body.organizationName.enabled,
      organizationNameDetail: body.organizationName.enabled ? body.organizationName.value : '',
    }
    return InjectorInstant.get(ApiService).post(routesConfig.userConfig, data);
  }

  shareResource(body: { contractQuantity: number; smsQuantity: number }) {
    return InjectorInstant.get(ApiService)
      .post(routes.shareResource(), body)
      .pipe(map(res => {
        return res;
      }));
  }

  setFontSize(id: string) {
    let el = document.getElementById(id);
    if (!el) {
      return;
    }
    el.style.wordBreak = 'break-word';
    if (id === imageConfigViewScaleId) {
      if (el && el.lastElementChild && el.lastElementChild.lastElementChild)
        el = el.lastElementChild.lastElementChild as HTMLElement;
    }

    if (el) {
      let fontSize = 28;
      let minSize = 16;
      let padding = 20;
      if (id === imageConfigFormPreviewId) {
        fontSize /= 2;
        minSize /= 2;
        padding /= 2;
      }

      console.log(el);
      el.style.fontSize = fontSize + 'px';

      const parent = el.parentElement;
      const parentHeight = parent.offsetHeight;
      let height = el.offsetHeight;

      while (height > parentHeight - padding && fontSize > minSize) {
        if (id === imageConfigFormPreviewId) {
          fontSize -= 1 / 2;
        } else {
          fontSize--;
        }
        el.style.fontSize = fontSize + 'px';
        height = el.offsetHeight;
      }
      console.log(fontSize);
    }
  }
}

